<template>
  <OwnStack class="dialog-footer" justify="end" spacing="3" row>
    <slot></slot>
  </OwnStack>
</template>

<script>
import { OwnStack } from '@/ui'

export default {
  name: 'DialogFooter',
  components: {
    OwnStack,
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  padding: 24px;
  border-top: 1px dashed $background-divider;
}
</style>
